import { render } from "./Order_management_update.vue?vue&type=template&id=d9b5d97e&scoped=true"
import script from "./Order_management_update.vue?vue&type=script&lang=js"
export * from "./Order_management_update.vue?vue&type=script&lang=js"

import "./Order_management_update.vue?vue&type=style&index=0&id=d9b5d97e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9b5d97e"]])

export default __exports__